import script from "./CompanyCreateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyCreateModal.vue?vue&type=script&setup=true&lang=js"

import "./CompanyCreateModal.vue?vue&type=style&index=0&id=59426f94&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59426f94"]])

export default __exports__